import * as React from 'react'
import cn from 'classnames'
import ModalWrapper from './ModalWrapper'
import CrossIcon from '../../icons/cross.svg'

interface IProps {
  title?: string
  closeable?: boolean
  onClose?: () => void
  containerClassName?: string
  /** Extra class on the portal element, to distinguish this modal from others. */
  modalClassName?: string
  /** Stable hook for automated testing, emitted as `data-testid`. */
  testId?: string
  children?: React.ReactNode
}

const Modal: React.FunctionComponent<IProps> = ({
  children,
  closeable = true,
  onClose,
  title,
  containerClassName = 'container',
  modalClassName,
  testId,
}) => {
  // Name the dialog off its visible title rather than an `aria-label`, which
  // would shadow `testId` for automation tooling. See ModalWrapper.
  const titleId = title && testId ? `${testId}-title` : undefined

  return (
    <ModalWrapper
      className={cn('modal', modalClassName)}
      testId={testId}
      labelledBy={titleId}
    >
      {/*<button className="clear-button modal_backdrop" onClick={onClose} />*/}

      {closeable && (
        <button
          className="clear-button link modal_close"
          onClick={onClose}
          data-testid={testId ? `${testId}-close` : undefined}
        >
          <CrossIcon />
        </button>
      )}

      <div className="modal_container">
        {title && (
          <div className="modal_title">
            <h2 id={titleId}>{title}</h2>
          </div>
        )}
        <div className={cn('modal_dialog', { '-tiny': !closeable })}>
          <div className="modal_inner-dialog">
            <div className={containerClassName}>{children}</div>
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}

export default Modal
